import { useEffect, useState } from 'react'

import { ConnectWebSocket, GetActiveStadiumZones, GetGenderMode, SaveUserZone, ValidateNumberZone } from './../../utilities/BL/Zones'


const Zones = ({ onZoneSaved }) => {
    const [selectedZone, setSelectedZone] = useState(0)
    const [errorMessage, setErrorMessage] = useState('')
    const [disabledButton, setDisabledButton] = useState(true)

    const [womensModeActive,setWomensModeActive] = useState(false)
    const [isWorking,setIsWorking] = useState(false)
    
    // NUEVO ESTADO PARA ZONAS DINÁMICAS
    const [dynamicZones, setDynamicZones] = useState([])

    // const ChangeListValue = async (e) => {
    //     try {
    //         setErrorMessage('')
    //         setSelectedZone(0)
            
    //         const option = parseInt(e.target.value)
            
    //         if (option >= 1 && option <= 11) {
    //             setDisabledButton(false)
    //             setSelectedZone(option)
    //         } else {
    //             setDisabledButton(true)
    //         }
    //     } catch (error) {
            
    //     }
    // }

    const ChangeListValue = async (e) => {
        setErrorMessage('')
        setSelectedZone(0)
        const option = parseInt(e.target.value)
        if (option > 0) {
            setDisabledButton(false)
            setSelectedZone(option)
        } else {
            setDisabledButton(true)
        }
    }

    // const SaveZone = async () => {
    //     try {
    //         setIsWorking(true)
    //         setErrorMessage('')
            
    //         if (selectedZone === 0) {
    //             setErrorMessage('Selecciona tu zona')
    //             return
    //         }

    //         // Validar id de zona elegida y obtener el nombre de la zona
    //         const responseValidate = await ValidateNumberZone(selectedZone)
    //         if (responseValidate.success) {

    //             const response = await SaveUserZone(responseValidate.data.text)
    //             if (!response.success) {
    //                 setErrorMessage(response.message)
    //                 return
    //             }

    //             // 2. Conectar WebSocket con la zona
    //             await ConnectWebSocket(response.data.text)

    //             // 3. Cambiar a vista Sections
    //             onZoneSaved()
    //         } else {
    //             setErrorMessage(responseValidate.message)
    //         }
    //     } catch (error) {
    //         console.error('SaveZone - Zones', error)
    //         setErrorMessage('Ocurrió un error al guardar la zona o conectar WebSocket')
    //     } finally {
    //         setIsWorking(false)
    //     }
    // }

    const SaveZone = async () => {
        try {
            setIsWorking(true)
            setErrorMessage('')
            if (selectedZone === 0) return setErrorMessage('Selecciona tu zona')

            // Buscamos la zona seleccionada en nuestra lista dinámica
            const selectedZoneData = dynamicZones.find(z => z.id === selectedZone);
            if (!selectedZoneData) return setErrorMessage('Zona no válida');

            // Guardamos usando el nombre "real/interno" que el backend espera (Ej. "azul")
            const response = await SaveUserZone(selectedZoneData.internalName)
            if (!response.success) return setErrorMessage(response.message)

            await ConnectWebSocket(response.data.text)
            onZoneSaved()
        } catch (error) {
            setErrorMessage('Ocurrió un error al guardar la zona')
        } finally {
            setIsWorking(false)
        }
    }

    const LoadPage = async () => {
        try {
            // Borrar clases de temas de colores
            // const classList = [
            //     "Colors--1--Primary",
            //     "Colors--1--Secondary",
            //     "Colors--2--Primary",
            //     "Colors--2--Secondary",
            //     "Colors--3--Primary",
            //     "Colors--4--Primary",
            //     "Colors--4--Secondary",
            //     "Colors--5--Primary",
            //     "Colors--5--Secondary",
            //     "Quiz__Background__Femenil--Blue",
            //     "Quiz__Background__Femenil--Golden"
            // ]


            // classList.forEach(item => {
            //     document.body.classList.remove(item)
            //     document.getElementById("fdmFooter")?.classList.remove(item)
            // })

            
            // Revisar si está activo el modo femenil para estableecerlo
            const responseWomensModeActive = await GetGenderMode()
            if (responseWomensModeActive.success && responseWomensModeActive.data.isWomensModeActive) {
                setWomensModeActive(true)
            }

            // NUEVO: Consultar al servidor las zonas activas
            const zonesRes = await GetActiveStadiumZones();
            if (zonesRes.success && zonesRes.data.length > 0) {
                setDynamicZones(zonesRes.data);
            } else {
                // FALLBACK: Si falla el servidor, pones tus zonas de emergencia aquí
                setDynamicZones([
                    { id: 1, displayName: "Zona Oriente (local)", internalName: "zona1" },
                    { id: 2, displayName: "Zona Poniente (visitante)", internalName: "zona2" },
                    { id: 9, displayName: "Zona Oriente (local)", internalName: "zona1" },
                    { id: 10, displayName: "Zona Poniente (visitante)", internalName: "zona2" }
                ]);
            }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        // <div className="Zones">
        //     <div className="Zones__ListContainer">
        //         <label className="Zones__ListContainer__Label" htmlFor="sZone">Selecciona tu zona:</label>
        //         <select id="sZone" className="Zones__ListContainer__List" value={selectedZone} onChange={ChangeListValue}>
        //             <option value={0}>Selecciona una zona</option>
        //             {/* RENDERIZADO DINÁMICO */}
        //             {/* {dynamicZones.map(zone => (
        //                 <option key={zone.id} value={zone.id}>
        //                     {zone.displayName}
        //                 </option>
        //             ))} */}

        //             {/* Carrera Atleti */}
        //             <option value={2}>Zona Lucho</option> {/* Canels */}
        //             <option value={5}>Zona Tunita</option> {/* Tecate */}
        //         </select>

        //         {disabledButton ? (
        //             <p className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardar</p>
        //         ) : isWorking ? (
        //             <button className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardando...</button>
        //         ) : (
        //             <>
        //                 <button className="Btn__Adsl--Red Zones__ListContainer__Button" onClick={SaveZone}>Guardar</button>
        //                 {errorMessage && <p className="Zones__ListContainer__Error">{errorMessage}</p>}
        //             </>
        //         )}
        //     </div>
        // </div>



        <div className="Zones">
            <div className="Zones__ListContainer">
                <label className="Zones__ListContainer__Label" htmlFor="sZone">Selecciona tu zona:</label>
                <select id="sZone" className="Zones__ListContainer__List" name="zone" value={selectedZone} onChange={(e) => ChangeListValue(e)}>
                    {womensModeActive ? (
                        <>
                            <option value={0}>Selecciona una zona</option>
                            {/* Daikin */}
                            {/*<option value={9}>Zona Pichon-kun</option>*/} {/* Zona Azul */}
                            {/*<option value={10}>Zona Tunita</option>*/} {/* Zona Oro */}

                            {/* La Moderna */}
                            {/* <option value={9}>Zona Codito</option> Zona Azul */}
                            {/* <option value={10}>Zona Spaghetti</option> Zona Oro */}

                            {/* Lucho y Tunita */}
                            {/* <option value={9}>Zona Lucho</option> Zona Azul
                            <option value={10}>Zona Tunita</option> Zona Oro */}

                            {/* Normal */}
                            {/* <option value={9}>Zona Azul</option>
                            <option value={10}>Zona Oro</option> */}

                            {/* Copa Escuelas ADSL */}
                            {/* <option value={9}>Team Lucho</option>
                            <option value={10}>Team Tunita</option> */}

                            {/* Santos Agnóstico */}
                            <option value={9}>Zona Oriente (local)</option>
                            <option value={10}>Zona Poniente (visitante)</option>
                        </>
                    ) : (
                        <>
                            <option value={0}>Selecciona una zona</option>
                            {/* Daikin */}
                            {/*<option value={2}>Zona Pichon-kun</option>*/} {/* Zona Canels */}
                            {/*<option value={5}>Zona Tunita</option>*/} {/*Zona Tecate */}

                            {/* La Moderna */}
                            {/*<option value={2}>Zona Codito</option>*/} {/* Zona Canels */}
                            {/*<option value={5}>Zona Spaghetti</option>*/} {/*Zona Tecate */}

                            {/* Lucho y Tunita */}
                            {/*<option value={2}>Zona Lucho</option>*/} {/* Zona Canels */}
                            {/*<option value={5}>Zona Tunita</option>*/} {/* Zona Tecate */}

                            {/* Copa Escuelas ADSL */}
                            {/* <option value={1}>Team Lucho</option>
                            <option value={2}>Team Tunita</option> */}

                            {/* Santos Agnóstico */}
                            <option value={1}>Zona Oriente (local)</option>
                            <option value={2}>Zona Poniente (visitante)</option>

                            {/* Normal }
                            <option value={1}>Zona Laboratorio Tequis</option>
                            <option value={2}>Zona San Luis</option> {/* Canels /}
                            <option value={3}>Zona Seguros El Potosí</option>
                            <option value={4}>Zona Red Cola</option>
                            <option value={5}>Zona Corona</option> {/* Tecate /}
                            <option value={6}>Zona Moctezuma</option>
                            <option value={7}>Zona Atleti</option> {/* Nissan /}
                            <option value={8}>Zona Mobil</option>
                            <option value={11}>Zona Palcos</option> {/* Lounge Ron Potosí */}
                        </>
                    )}
                </select>

                {disabledButton ? (
                    <p className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardar</p>
                ) : (
                    isWorking ? (
                        <>
                            <button className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardando...</button>
                        </>
                    ) : (
                        <>
                            <button className="Btn__Adsl--Red Zones__ListContainer__Button" onClick={SaveZone}>Guardar</button>
                            {errorMessage && <p className="Zones__ListContainer__Error">{errorMessage}</p>}
                        </>
                    )
                )}
            </div>
        </div>
    )
}

export { Zones };















// const Zones = ({ onZoneSaved }) => {
//     const [selectedZone, setSelectedZone] = useState(0)
//     const [errorMessage, setErrorMessage] = useState('')
//     const [disabledButton, setDisabledButton] = useState(true)

//     const [womensModeActive,setWomensModeActive] = useState(false)
//     const [isWorking,setIsWorking] = useState(false)
    

//     const ChangeListValue = async (e) => {
//         try {
//             setErrorMessage('')
//             setSelectedZone(0)
            
//             const option = parseInt(e.target.value)
            
//             if (option >= 1 && option <= 10) {
//                 setDisabledButton(false)
//                 setSelectedZone(option)
//             } else {
//                 setDisabledButton(true)
//             }
//         } catch (error) {
            
//         }
//     }

//     const SaveZone = async () => {
//         try {
//             setIsWorking(true)
//             setErrorMessage('')
            
//             if (selectedZone === 0) {
//                 setErrorMessage('Selecciona tu zona')
//                 return
//             }

//             // Validar id de zona elegida y obtener el nombre de la zona
//             const responseValidate = await ValidateNumberZone(selectedZone)
//             if (responseValidate.success) {

//                 const response = await SaveUserZone(responseValidate.data.text)
//                 if (!response.success) {
//                     setErrorMessage(response.message)
//                     return
//                 }

//                 // 2. Conectar WebSocket con la zona
//                 await ConnectWebSocket(response.data.text)

//                 // 3. Cambiar a vista Sections
//                 onZoneSaved()
//             } else {
//                 setErrorMessage(responseValidate.message)
//             }
//         } catch (error) {
//             console.error('SaveZone - Zones', error)
//             setErrorMessage('Ocurrió un error al guardar la zona o conectar WebSocket')
//         } finally {
//             setIsWorking(false)
//         }
//     }

//     const LoadPage = async () => {
//         try {
//             // Borrar clases de temas de colores
//             const classList = [
//                 "Colors--1--Primary",
//                 "Colors--1--Secondary",
//                 "Colors--2--Primary",
//                 "Colors--2--Secondary",
//                 "Colors--3--Primary",
//                 "Colors--4--Primary",
//                 "Colors--4--Secondary",
//                 "Colors--5--Primary",
//                 "Colors--5--Secondary",
//                 "Quiz__Background__Femenil--Blue",
//                 "Quiz__Background__Femenil--Golden"
//             ]


//             classList.forEach(item => {
//                 document.body.classList.remove(item)
//                 document.getElementById("fdmFooter")?.classList.remove(item)
//             })

            
//             // Revisar si está activo el modo femenil para estableecerlo
//             const responseWomensModeActive = await GetGenderMode()
//             if (responseWomensModeActive.success && responseWomensModeActive.data.isWomensModeActive) {
//                 setWomensModeActive(true)
//             }
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         LoadPage()
//     }, [])


//     return (
//         <div className="Zones">
//             <div className="Zones__ListContainer">
//                 <label className="Zones__ListContainer__Label" htmlFor="sZone">Selecciona tu zona:</label>
//                 <select id="sZone" className="Zones__ListContainer__List" name="zone" value={selectedZone} onChange={(e) => ChangeListValue(e)}>
//                     {womensModeActive ? (
//                         <>
//                             <option value={0}>Selecciona una zona</option>
//                             <option value={9}>Zona Azul</option>
//                             <option value={10}>Zona Oro</option>
//                         </>
//                     ) : (
//                         <>
//                             <option value={0}>Selecciona una zona</option>
//                             <option value={1}>Zona Laboratorio Tequis</option>
//                             <option value={2}>Zona Canels</option>
//                             <option value={3}>Zona Seguros El Potosí</option>
//                             <option value={4}>Zona Red Cola</option>
//                             <option value={5}>Zona Tecate</option>
//                             <option value={6}>Zona Moctezuma</option>
//                             <option value={7}>Zona Nissan</option>
//                             <option value={8}>Zona Mobil</option>
//                         </>
//                     )}
//                 </select>

//                 {disabledButton ? (
//                     <p className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardar</p>
//                 ) : (
//                     isWorking ? (
//                         <>
//                             <button className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardando...</button>
//                         </>
//                     ) : (
//                         <>
//                             <button className="Btn__Adsl--Red Zones__ListContainer__Button" onClick={SaveZone}>Guardar</button>
//                             {errorMessage && <p className="Zones__ListContainer__Error">{errorMessage}</p>}
//                         </>
//                     )
//                 )}
//             </div>
//         </div>
//     )
// }

// export { Zones };